import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import ActionIcon from 'components/lib/DesignSystem/ActionIcon'

import { Info } from './DesignSystem/Icons'
import Tooltip from './DesignSystem/Tooltip'
import InformationIcon from './InformationIcon'

const LabelText = ({
  text,
  className,
  style,
  disabled,
  readOnly,
  id,
  notification,
  tooltipText,
}) => {
  const theme = useContext(ThemeContext)
  let labelColor = theme.ds_gray_3

  if (disabled) labelColor = theme.ds_gray_5
  if (readOnly) labelColor = theme.ds_gray_3

  return (
    <p id={`${id}_label`} style={{ ...style, color: labelColor }} className={className}>
      <span className="typography-body-2">{text}</span>
      {notification && (
        <Tooltip
          placement="right"
          overlayStyle={{
            maxWidth: '250px',
            whiteSpace: 'normal',
          }}
          text={notification}
        >
          <ActionIcon
            Icon={Info}
            containerStyle={{ marginLeft: '2px' }}
            iconProps={{ width: '18px', height: '18px' }}
          />
        </Tooltip>
      )}
      {tooltipText && <InformationIcon tooltipText={tooltipText} id={id} />}
    </p>
  )
}
export default styled(LabelText)`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0 0 4px;
  .icon {
    margin-left: 4px;
  }
`
